import { useState } from 'react';
import { Shield, Bell, BarChart3, Calendar, GraduationCap, Users } from 'lucide-react';
import FeatureCard from '../ui/FeatureCard';

// Section primary-800 (#122C5A) — registre "sombre chaud", entre le Hero primary-950 et le Workflow clair.
const FeaturesSection = () => {
  const [activeTab, setActiveTab] = useState('parents');

  return (
    <section id="features" className="bg-primary-800">
      <div className="py-20">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="font-display text-3xl md:text-4xl font-bold text-white mb-4">
              Deux métiers, un même fil.
            </h2>
            <p className="font-sans text-sky-muted max-w-2xl mx-auto">
              Le parent suit et rassure. Le répétiteur organise et enseigne. Chacun son espace, les mêmes informations à jour.
            </p>
            {/* Barre accent orange — signal de section, écho au Workflow */}
            <div className="w-12 h-1 rounded-full bg-accent mx-auto mt-4" aria-hidden="true" />
          </div>

          {/* Toggle onglets : piste glass, segment actif en accent */}
          <div className="flex justify-center mb-12">
            <div className="bg-white/5 border border-white/10 p-1 rounded-full inline-flex">
              <button
                onClick={() => setActiveTab('parents')}
                className={`px-8 py-3 rounded-full font-sans font-medium transition-all duration-300 ${
                  activeTab === 'parents'
                    ? 'bg-accent text-primary shadow-soft'
                    : 'text-sky-muted hover:text-white'
                }`}
              >
                Espace parent
              </button>
              <button
                onClick={() => setActiveTab('tutors')}
                className={`px-8 py-3 rounded-full font-sans font-medium transition-all duration-300 ${
                  activeTab === 'tutors'
                    ? 'bg-accent text-primary shadow-soft'
                    : 'text-sky-muted hover:text-white'
                }`}
              >
                Espace répétiteur
              </button>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {activeTab === 'parents' ? (
              <>
                {/* Icônes success/accent : deux couleurs max pour ne pas bigarrer */}
                <FeatureCard
                  icon={<Shield className="text-success" size={32} />}
                  title="Vous savez ce qui se passe"
                  desc="Chaque séance et son état (prévu, réalisé, annulé), l'historique complet et le compte-rendu du dernier cours, réunis sur un tableau de bord."
                />
                <FeatureCard
                  icon={<Bell className="text-accent" size={32} />}
                  title="Rien ne vous échappe"
                  desc="Un rappel la veille de chaque séance, le compte-rendu dès la fin du cours, une alerte en cas d'annulation. Vous n'avez plus à relancer."
                />
                <FeatureCard
                  icon={<BarChart3 className="text-success" size={32} />}
                  title="La progression, en clair"
                  desc="Notes, moyennes par matière et par trimestre calculées automatiquement selon le système scolaire. Vous voyez l'évolution, pas seulement une note isolée."
                />
              </>
            ) : (
              <>
                <FeatureCard
                  icon={<Calendar className="text-success" size={32} />}
                  title="Votre planning se remplit tout seul"
                  desc="Définissez vos cours fixes : les séances se génèrent automatiquement. Vacances et pauses en un clic, sans tout ressaisir."
                />
                <FeatureCard
                  icon={<GraduationCap className="text-accent" size={32} />}
                  title="Notes et moyennes sans calculatrice"
                  desc="Saisissez interros (IE) et devoirs (DS) avec leur pondération. MyEduCycle calcule les moyennes par matière et par trimestre à votre place."
                />
                <FeatureCard
                  icon={<Users className="text-success" size={32} />}
                  title="Le lien avec les parents, sans WhatsApp"
                  desc="Invitez un parent par e-mail ou code famille, rédigez le compte-rendu en fin de séance, proposez une nouvelle date en cas d'annulation. Tout est tracé, tout est clair."
                />
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
